module.exports = __webpack_public_path__ + "img/monitorbox08.5adf6dd7.jpg";